import { useEffect, useState } from 'react';
import { Button } from '@eventbrite/marmalade';
import { useIntl } from 'react-intl';
import { ContactModal } from './ContactModal';
import styles from './ContactButton.module.scss';

interface Props {
  organizerId: string;
  eventbriteBaseUrl: string;
}

export function ContactButton({ organizerId }: Props) {
  const intl = useIntl();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('contact_organizer') === 'true') {
      setIsModalOpen(true);
    }
  }, []);

  return (
    <div className={styles.contactSlot}>
      <Button
        variant="secondary"
        sizeVariant="medium"
        type="button"
        onClick={() => setIsModalOpen(true)}
      >
        {intl.formatMessage({ id: 'Contact', defaultMessage: 'Contact' })}
      </Button>
      <ContactModal
        isShown={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        organizerId={organizerId}
      />
    </div>
  );
}
